import { Base64 } from 'js-base64';
import config from 'config/images';

const {
  CDN, imageloader, objectImagesWebp, objectImageGallery
} = config;

const md5 = require('md5'); // md5 libary ssr save (https://github.com/pvorb/node-md5)


const ImageLoader = {
  methods: {
    /**
     * returns object image url as jpg or webp
     * to return/create webp image, just add "_webp" to size param -> "725x450_webp"
     * can be cdn url
     *  - https://cdn.e-domizil.de/photos/0d65eb80a133f3e01a865fd80beefe62_725x450.jpg
     *  - https://cdn.e-domizil.de/photos/0d65eb80a133f3e01a865fd80beefe62_725x450.webp
     * or imageloader url if image size is not in ES (301 to cdn-url)
     *  - https://imageloader.e-domizil.de/photos/725x450/aHR0cHM6Ly9kbzJzeWNhZnU1YXc4LmNsb3VkZnJvbnQubmV0Lzg0NTAwMC9oODQ1NDY3L29yaWdpbmFsL2g4NDU0NjdfMS5qcGc%2FMjAyMTA3MTUxMzQxNTE%3D/2770303
     *  - https://imageloader.e-domizil.de/photos/725x450_webp/aHR0cHM6Ly9kbzJzeWNhZnU1YXc4LmNsb3VkZnJvbnQubmV0Lzg0NTAwMC9oODQ1NDY3L29yaWdpbmFsL2g4NDU0NjdfMS5qcGc%2FMjAyMTA3MTUxMzQxNTE%3D/2770303
     *
     * "org" or "org_webp" is also a size param (like "725x450" or "725x450_webp")
     * imageloader interprets it as original size and creates an img with max 1400px width, but no stretching
     * org image will be uploaded as
     * jpg https://cdn.e-domizil.de/photos/b3d419dd6fdc374af82e352aa0696b9d_org.jpg
     * webp https://cdn.e-domizil.de/photos/b3d419dd6fdc374af82e352aa0696b9d_org.webp
     */
    imageLoader(size, src, object, cdn) {
      const sizeParam = size;

      // EDVUE-2938 load every fourth object with webp images
      // if (object % 4 === 0 && !sizeParam.match(/_webp/)) {
      //   sizeParam += '_webp';
      // }

      let extension = '.jpg';
      let sizePathCdn = sizeParam;
      const sizePathImageLoader = sizeParam;
      if (sizeParam.match(/_webp/)) {
        extension = '.webp';
        sizePathCdn = sizePathCdn.replace('_webp', '');
      }

      // return cdn domain if uploaded includes requested size
      if (cdn && sizeParam && src && cdn.indexOf(sizeParam) > -1) {
        return `${this.cdn}/photos/${encodeURIComponent(md5(src))}_${sizePathCdn}${extension}`;
      }
      // return imageloader domain if image not uploaded to cdn yet
      if (sizeParam && src) {
        return `//${this.imageloader}/photos/${sizePathImageLoader}/${encodeURIComponent(Base64.encode(src))}${(object) ? `/${object}` : ''}`;
      }
      return '';
    },
  },
  computed: {
    imageloader() {
      return imageloader || 'imageloader.tourist-online.de';
    },
    cdn() {
      return `${CDN}` || 'cdn.tourist-online.de';
    },
    ilMixin_objectImagesWebp() {
      return objectImagesWebp || false;
    },
    ilMixin_objectImageGallery() {
      return objectImageGallery || 'grid';
    },
  },
};

export default ImageLoader;
